// src/admin/components/Notification.tsx
import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaExclamationTriangle } from 'react-icons/fa';

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'info'; 
  onClose: () => void;
  duration?: number; 
}

const Notification: React.FC<NotificationProps> = ({ message, type, onClose, duration = 4000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose(); 
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const bgColorClass = {
    success: 'bg-green-500 dark:bg-green-600', // Thoda dark green dark mode me
    error: 'bg-red-500 dark:bg-red-600',
    info: 'bg-blue-500 dark:bg-blue-600',
  }[type];

  const iconComponent = {
    success: <FaCheckCircle className="text-white text-xl mr-3" />,
    error: <FaTimesCircle className="text-white text-xl mr-3" />,
    info: <FaExclamationTriangle className="text-white text-xl mr-3" />,
  }[type];

  if (!isVisible) return null;

  return (
    <div
      className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg text-white flex items-center transition-opacity duration-300 z-50 transform translate-x-0 opacity-100 
      ${bgColorClass} border border-transparent dark:border-gray-600`} // Added dark border
      role="alert"
    >
      {iconComponent}
      <span className="font-semibold text-lg">{message}</span>
      <button
        onClick={() => {
          setIsVisible(false);
          onClose();
        }}
        className="ml-4 text-white text-xl p-1 rounded-full hover:bg-white hover:bg-opacity-20 transition-all"
        aria-label="Close notification"
      >
        &times;
      </button>
    </div>
  );
};

export default Notification;